/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmailTemplate } from '../../models/email-template';

export interface ApiSupportEmailTemplateGetAllGet$Params {
}

export function apiSupportEmailTemplateGetAllGet(http: HttpClient, rootUrl: string, params?: ApiSupportEmailTemplateGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EmailTemplate>>> {
  const rb = new RequestBuilder(rootUrl, apiSupportEmailTemplateGetAllGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EmailTemplate>>;
    })
  );
}

apiSupportEmailTemplateGetAllGet.PATH = '/api/Support/EmailTemplate/GetAll';
